import { render, staticRenderFns } from "./complaintsSatisfaction.vue?vue&type=template&id=0831e027&scoped=true"
import script from "./complaintsSatisfaction.vue?vue&type=script&lang=js"
export * from "./complaintsSatisfaction.vue?vue&type=script&lang=js"
import style0 from "./complaintsSatisfaction.vue?vue&type=style&index=0&id=0831e027&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831e027",
  null
  
)

export default component.exports